var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileLoadingIcon = function SvgFileLoadingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DF7E0C",
    fillRule: "evenodd",
    d: "M7.25 14.667a.75.75 0 0 0 1.5 0V12.44a.75.75 0 1 0-1.5 0zm0-11.104a.75.75 0 0 0 1.5 0V1.334a.75.75 0 0 0-1.5 0zm6.19.059a.75.75 0 0 0-1.06-1.061l-1.576 1.576a.75.75 0 0 0 1.06 1.06zm-8.242 8.242a.75.75 0 0 0-1.06-1.06L2.56 12.38a.75.75 0 0 0 1.06 1.06zM3.622 2.561a.75.75 0 0 0-1.06 1.06l1.575 1.577a.75.75 0 0 0 1.06-1.06zm8.242 8.243a.75.75 0 1 0-1.06 1.06l1.576 1.576a.75.75 0 0 0 1.06-1.06zM.584 8a.75.75 0 0 1 .75-.75h2.229a.75.75 0 0 1 0 1.5H1.334A.75.75 0 0 1 .584 8m11.104 0a.75.75 0 0 1 .75-.75h2.23a.75.75 0 0 1 0 1.5h-2.23a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};
export default SvgFileLoadingIcon;